(function() {
    'use strict';

    angular
        .module('backApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('security/api/store-users/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) { 
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
